import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import FunctionalCategories from './functional-categories'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faExclamationTriangle,
  faUser,
  faExclamationCircle,
  faPowerOff,
  faLayerGroup,
  faRandom
} from '@fortawesome/free-solid-svg-icons'

function Stats({ role, setActiveTab, showPermissions }) {
  const [functionalModalShow, setFunctionalModalShow] = useState(false)
  const navigate = useNavigate()

  const stats = [
    {
      name: 'Internal Conflicts',
      icon: (
        <FontAwesomeIcon icon={faExclamationTriangle} className="text-danger" />
      ),
      value: role.internal_conflicts_count,
      onClick: () => {
        setActiveTab('conflicts')
      }
    },
    {
      name: 'Users (Enabled)',
      icon: <FontAwesomeIcon icon={faUser} className="text-primary" />,
      value: role.employees_count,
      onClick: () => {
        setActiveTab('employees')
      }
    },
    {
      name: 'High Risk Permissions',
      icon: (
        <FontAwesomeIcon icon={faExclamationCircle} className="text-warning" />
      ),
      value: role.high_risk_permissions_count,
      onClick: () => {
        showPermissions({ is_high_risk: true })
        navigate(`?is_high_risk=true`, { replace: true })
      }
    },
    {
      name: 'Super User Permissions',
      icon: <FontAwesomeIcon icon={faPowerOff} className="text-danger" />,
      value: role.superuser_permissions_count,
      onClick: () => {
        showPermissions({ is_super_user: true })
        navigate(`?is_super_user=true`, { replace: true })
      }
    },
    {
      name: 'Business Rules',
      icon: <FontAwesomeIcon icon={faRandom} className="text-primary" />,
      value: role.business_rules_count,
      onClick: () => {
        setActiveTab('business-rules')
      }
    },
    {
      name: 'Functional Categories',
      icon: <FontAwesomeIcon icon={faLayerGroup} className="text-primary" />,
      value: role.functional_categories_count,
      onClick: () => {
        setFunctionalModalShow(true)
      }
    }
  ]

  return (
    <>
      <style jsx>{`
        .stat-item:hover span {
          text-decoration: underline;
        }
      `}</style>
      <div>
        <FunctionalCategories
          role={role}
          show={functionalModalShow}
          setShow={setFunctionalModalShow}
          showPermissions={showPermissions}
        />
      </div>
      <Row>
        {stats.map((stat, index) => (
          <Col key={`${stat.name}-index`} sm={'auto'}>
            <div
              onClick={stat.onClick}
              style={{ cursor: 'pointer' }}
              className="stat-item"
            >
              <>
                {stat.icon}
                <span className="text-muted ms-1">{stat.value}</span>
                <span className="text-muted ms-1">{stat.name}</span>
              </>
            </div>
          </Col>
        ))}
      </Row>
    </>
  )
}

export default Stats
